import estruturaComponentes from './componentsProperties';
import estruturaComponentesInternos from './componentsInternalProperties';
import { setRowUiProp, PERSISTED_ROW_PROPS } from './rowUiState';
//import Vue from 'vue';

const componentMixin = {
   
    props: {
        cp                  : Object,
        state               : Object,
        idTela              : String,
        childrens           : Array
    },

    data() {
        return {
            componentKey: this.$utils.getComponentIDMixin({
                cpId: this.cp?.id,
                stateKey: this.state?.key
            }),
        };
    },

    created() {
        this._compiledEvents = {};
        this.criarPropriedadesDoComponente(this.$options.name);
        // if(this.$scripts){
        //     for(let module of this.$scripts){
        //         Vue.prototype[module.id] = eval(module.script);
        //     };
        // };

        this._execEvent('created');
    },

    mounted() {        
        this.commitProperties();
        this._execEvent('mounted');
    },

    updated() {
        this.commitProperties();
        this._execEvent('updated');
    },

    methods: {
        _getCompiledEvent(eventName, locals = {}, promise=false) {
            const code = this.lodash.get(this.cp, ['events', eventName]);

            if (!code) {
                return undefined;
            }

            this._compiledEvents = this._compiledEvents || {};

            const paramNames  = Object.keys(locals);
            const cacheKey    = `${eventName}:${promise ? 'promise' : 'event'}:${paramNames.join(',')}`;
            const cachedEvent = this._compiledEvents[cacheKey];

            if (cachedEvent && cachedEvent.code === code) {
                return cachedEvent.fn;
            }

            try {
                const fnName = `${this.$options.name}_${this.lodash.get(this.cp, 'id', 'component')}_${eventName}`
                    .replace(/[^a-zA-Z0-9_$]/g, '_');
                const body = promise
                    ? `return function ${fnName}(${paramNames.join(',')}) {\nreturn new Promise((resolve, reject) => {\n${code}\n});\n}`
                    : `return function ${fnName}(${paramNames.join(',')}) {\n${code}\n}`;
                const fn = new Function(body)();

                this._compiledEvents[cacheKey] = { code, fn };
                return fn;
            } catch (e) {
                const eventType = promise ? 'evento promise' : 'evento';
                console.error(`[${this.$options.name} - ${this.lodash.get(this.cp, 'id')}] Falha ao compilar ${eventType} '${eventName}': ${e}`);
                this._compiledEvents[cacheKey] = { code, fn: null };
                return undefined;
            }
        },

        _execEvent(eventName, locals = {}) {
            const fn = this._getCompiledEvent(eventName, locals);

            if (!fn) { return undefined; }

            try {
                const result = fn.call(this, ...Object.values(locals));
                if (result && typeof result.then === 'function') {
                    result.catch(e => {
                        console.error(`[${this.$options.name} - ${this.lodash.get(this.cp, 'id')}] Falha ao executar evento '${eventName}': ${e}`);
                    });
                }
                return result;
            } catch (e) {
                console.error(`[${this.$options.name} - ${this.lodash.get(this.cp, 'id')}] Falha ao executar evento '${eventName}': ${e}`);
            }
        },

        _execEventPromise(eventName, locals = {}) {
            const fn = this._getCompiledEvent(eventName, locals, true);
            if (!fn) {
                return Promise.resolve();
            }

            try {
                return (fn.call(this, ...Object.values(locals)) || Promise.resolve())
                    .catch(e => {
                        console.error(`[${this.$options.name} - ${this.lodash.get(this.cp, 'id')}] Falha ao executar evento promise '${eventName}': ${e}`);
                    });
            } catch (e) {
                console.error(`[${this.$options.name} - ${this.lodash.get(this.cp, 'id')}] Falha ao executar evento promise '${eventName}': ${e}`);
                return Promise.resolve();
            }
        },

        $getNavbarComponents(){
            return this.$store.getters[`mainFramework/getPropriedades`];
        },

        $setAllChildrenProps(prop, value) {
            const mudarValores = (cp, prop, valor) => {
                
                const compKey          = this.lodash.get(cp, "id", cp);
                const propriedadesTela = this.$getComponents();
        
                const processarLista = (lista) => {
                    lista.forEach((item) => {
                        const listComponentsKey = Object.keys(item);
        
                        listComponentsKey.forEach((key) => {
                            this.lodash.get(item, [key, "setPropValue"], () => {})(prop, valor);
        
                            this.lodash.each(this.lodash.get(item, [key, "childrens"]), 
                                comp => mudarValores(comp, prop, valor)
                            );
                        });
                    });
                };
        
                if (propriedadesTela[compKey] && propriedadesTela[compKey].$getRowComponents) {
                    const propriedadesLista = propriedadesTela[compKey].rows;
                    processarLista(propriedadesLista);

                } else {
                    this.lodash.get(propriedadesTela, [compKey, "setPropValue"], () => {})(prop, valor);
                    
                    this.lodash.each(this.lodash.get(propriedadesTela, [compKey, "childrens"]), 
                        comp => mudarValores(comp, prop, valor)
                    );
                }
            };
        
            mudarValores(this.cp, prop, value);
        },
        

        $getComponents() {
            return this.$getPropriedades(this);
        },

        $getComponentsPromise() {
            return new Promise((resolve, reject) => {
                for (let tentativa=0; tentativa < 20; tentativa++) {
                    if  (this.$getPropriedades(this)) {
                        return resolve(this.$getComponents(this));
                    } else {
                        setTimeout(() => $getComponents(), 50);
                    }
                }
                resolve(undefined);
            });  
        },

        $toggleRowDetails(){
            // this.$applyRowComponents(this.state.row);

            // Quando um input tem o valor alterado, caso feche e abra novamente os detalhes da row, o item perde o valor.
            // criar solução

            this.state.row.toggleDetails();
        },

        $getRowComponents(row) {
            let propriedadesTela = this.$store.getters[`${this.idTela}/getPropriedades`];
            let propriedadesComponentePai = propriedadesTela[this.state.parent.id];

            let componentesRow = propriedadesComponentePai.rows || [];
            return componentesRow[row || this.rowIndex] || {};
        },

        $applyRowComponents(row){
            const components = this.$getRowComponents(row);
            for (const comp in components) {
                if  (this.isInputComponent(components[comp].component)) {                    
                    if  (components[comp].apply) {
                        components[comp].apply();
                    }
                }
            }
        },

        $undoRowComponents(row){
            const components = this.$getRowComponents(row);
            for (const comp in components) {
                if  (this.isInputComponent(components[comp].component)) {                    
                    if  (components[comp].undo) {
                        components[comp].undo();
                    }
                }
            }
        },

        $hasRowComponentsValueChanged(row) {
            let changed = false;
            const components = this.$getRowComponents(row);
            for (const comp in components) {
                if  (components[comp].isValueChanged) {
                    changed = changed || components[comp].isValueChanged();
                }
            }
            return changed;
        },

        $getSlot(slotId) {
            if  (this.lodash.get(this, "cp.childrens",[]).length > 0) { 
                let retorno = undefined;
                if  (slotId == "default") {
                    retorno = this.cp.childrens.filter((child) => (child.props.slot == slotId || child.props.slot == "" || child.props.slot == undefined));
                } else {
                    retorno = this.cp.childrens.filter((child) => (child.props.slot == slotId));
                }
                if  (retorno && retorno.length) {
                    return retorno;
                } else {
                    return undefined;
                }
            }
		},

        commitProperties() {            
            let defaultProps = {
                ...this.cp,
                ...this.public,
                refs: this.$refs,
                state: this.state,
                setPropValue : this.setPropValue,
                setPropEval  : this.setPropEval,
                getPropValue : this.getPropValue,
                setAllChildrenProps : this.$setAllChildrenProps
            };

            if  (this.lodash.get(this, 'state.parent.component') == 'ClicTable' || 
                this.lodash.get(this, 'state.parent.component') == 'ClicCatalog' || 
                this.lodash.get(this, 'state.parent.component') == 'ClicKanban' || 
                this.lodash.get(this, 'state.parent.component') == 'ClicList') {  

                let baseIndex =  this.state.row.index;
                if(this.state.parent.optimizedList){
                    this.rowIndex = baseIndex.toString();
                }else{
                    this.rowIndex = (baseIndex + '') *1;
                }

                let propriedadesTela = this.$store.getters[`${this.idTela}/getPropriedades`];
                let propriedadesTable = propriedadesTela[this.state.parent.id];
                propriedadesTable.rows = propriedadesTable.rows || [];
                propriedadesTable.rows[this.rowIndex] = propriedadesTable.rows[this.rowIndex] || {};
                propriedadesTable.rows[this.rowIndex][this.cp.id] = {
                    ...defaultProps,
                    index: this.rowIndex
                };

                this.$store.commit(`${this.idTela}/setPropriedades`, {[`${this.state.parent.id}`] : {                        
                        ...propriedadesTable,                                 
                        $getRowComponents : this.$getRowComponents,                        
                    }
                });                              

            } else if  (this.cp && Object.keys(this.cp).length && this.idTela) {
                let propsAtuais = {};
                let componentesTela = this.$store.getters[`${this.idTela}/getPropriedades`];
                let componenteAtual = componentesTela[this.cp.id];
                if  (componenteAtual) {
                    propsAtuais = componenteAtual;
                }

                let modifiedObject = {...propsAtuais, ...defaultProps}
                if(modifiedObject.rows) {modifiedObject.rows = propsAtuais.rows || defaultProps.rows}

                if (!this.lodash.isEqual(componenteAtual, modifiedObject)) {
                    this.$store.commit(`${this.idTela}/setPropriedades`, {[`${this.cp.id}`] : modifiedObject});  
                }
            }
        },

        criarPropriedadesDoComponente(nomeComponente) {
            let estruturaDoComponente = estruturaComponentes()[nomeComponente];
            if  (estruturaDoComponente) {
                let props = estruturaDoComponente.props;
                let propsNames = Object.keys(props);

                for (let prop of propsNames) {
                    //this[prop] = this.lodash.get(this.cp, 'props.'+prop, this.lodash.get(props[prop], 'default', undefined));

                    let valor = this.lodash.get(this.cp, 'props.'+prop, this.lodash.get(props[prop], 'default', undefined));

                    try {
                        let valorEval = eval(valor);
                        //this[prop] = valorEval;
                        valor = valorEval;
                    } catch (e) { }

                    //this.cp.props[prop] = valor;
                    this[prop] = valor;
                    
                    if  (estruturaComponentesInternos()[prop]) {
                        delete this[prop];
                        const internalProps = estruturaComponentesInternos()[prop];
                        const propsInternalNames = Object.keys(internalProps);
                        
                        for (let propI of propsInternalNames) {
                            this[propI] = this.lodash.get(this.cp, 'props.'+propI, this.lodash.get(internalProps, propI+'.default', undefined));                                                        
                        }
                    }
                }
            }
        },

        destroy() {
            this.$destroy();
            this.$el.parentNode.removeChild(this.$el);
        },

        reload(force=false) {
            this.$forceUpdate();
            // if  (force) {
            //     this.componentKey = this.$utils.getComponentID();
            // }
        },

        setPropValue(name, value) {
            try {
                this.cp.props[name] = value;
                this[name] = value;

                // Em lista otimizada, persiste o valor num store reativo por linha
                // (indexado por _id), fora da instância. Assim o valor sobrevive à
                // reciclagem/realocação de instância do RecycleScroller e ao scroll:
                // qualquer instância que renderize a linha lê o valor certo via getProp.
                // Só as props da allowlist (lidas via getProp) são persistidas.
                if (this.state?.parent?.optimizedList && PERSISTED_ROW_PROPS.has(name)) {
                    setRowUiProp(
                        this.state?.parent?.id,
                        this.state?.row?.index,
                        this.cp?.id,
                        name,
                        value
                    );
                }

                this.reload();
                
            } catch (e) {
                console.error(`[${this.$options.name} - ${this.cp.id}] Falha ao alterar a propriedade ${name}, valor: '${value}'. Detalhes: ${e}`);
            }
        },

        setPropValueAndCommit(name, value) {
            try {
                let comp = this.$getComponents()
                if(comp[this.cp.id]){
                    comp[this.cp.id][name] = value
                    this.$store.commit(`${this.idTela}/setPropriedades`,
                         {[`${this.cp.id}`] : {...comp[this.cp.id]}
                    });
                }
            } catch (e) {
                console.error(`[${this.$options.name} - ${this.cp.id}] Falha ao alterar a propriedade ${name}, valor: '${value}'. Detalhes: ${e}`);
            }
        },

        setPropEval(name, value) {
            try {
                const novoValor = eval(value);
                setPropValue(name, novoValor);
            } catch (e) {
                console.error(`[${this.$options.name} - ${this.cp.id}] Falha ao alterar a propriedade ${name} (EVAL), valor: '${value}'. Detalhes: ${e}`);
            }
        },

        getPropValue(name) {
            return this[name];
        },

        isInputComponent(comp){
            const component = comp || this.cp.component;
            if ( component == "ClicInput"  ||
                component == "ClicInputMask" ||
                component == "ClicInputCurrencyMask" ||
                component == "ClicMultiselect" ||
                component == "ClicDatePicker" ||
                component == "ClicTextArea" ||
                component == "ClicSwitch" ||
                component == "ClicMarkdown") {
                
                return true;
            }
            return false;
        },  

        getInputComponentsFromComponent(component){
            let retorno = [];
            const getInput = (cp) => {
                if (this.isInputComponent(cp.component)) {
                    retorno.push(cp);
                } else {
                    if (cp.childrens && cp.childrens.length > 0){
                        for (let comp of cp.childrens){
                            getInput(comp);
                        }
                    }
                }
            };
            getInput(component);
            return retorno;
        },

        clearField(){
            if (this.isInputComponent()) {
                this.value = undefined;
            }
        },

        /*
        undo() {
            this.value = this.oldValue;
        },
        apply() {
            this.oldValue = this.value;
        },
        isValueChanged() {
            return this.oldValue != this.value;
        }, */

        async validateField(){
            if(this.isInputComponent()){
                if((this.lodash.has(this.cp, "props.required") && (this.cp.props.required === true) &&  (this.lodash.has(this.cp, "props.visible") 
                    && this.cp.props.visible === true) && (this.value === undefined || this.value == ""))){
                    
                    this.fieldState             = false;
                    this.invalidFeedbackMessage = this.lodash.get(this.cp, "props.invalidFeedbackMessage", "");
                    return false;
                }
                    
                if(this.lodash.has(this.cp, 'props.validateScript') && 
                    (this.lodash.has(this.cp, "props.visible") && this.cp.props.visible === true) && this.value != undefined && this.value != ""){
                    
                    let scripts = eval(this.cp.props.validateScript),
                    isValid = false;
        
                    for(let validate of scripts){
                        try{
                            if(this.lodash.has(validate, 'script')){
                            
                            let validatePromise = () => {
                                return new Promise((resolve, reject) => {
                                    let _this = this;
                                    let formatedScript = validate.script.replaceAll("this.", "_this.");
                                    eval(formatedScript);
                                });
                            };
                            if(await validatePromise()){
                                this.fieldState = undefined;
                                isValid         = true;
                            }else{
                                this.fieldState             = false;
                                this.invalidFeedbackMessage = this.lodash.get(validate, "message", "");
                                break;
                            }
                        };
                        
                        }catch(e){
                            console.error(`${this.cp.component} > ${this.cp.id} | Ocorreu um erro durante a execução do método validateField. ${e}`);
                        }
                    }
                    return isValid;
                }else{
                    return true;
                }
            }   
        },

    },


   };
 
   export default componentMixin;
